module.exports = __webpack_public_path__ + "static/father-daughter-market.33d739e5.jpg";